import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  AvatarStack,
  PopperDialog,
} from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { collaboratorSummaryShape } from 'Workspace/types/collaborator';

import InviteView from './InviteView';
import AvatarsPlaceholder from './AvatarsPlaceholder';

import messages from './messages';

class SharingDialog extends React.Component {
  state={
    isOpen: false,
  };

  toggleDialog = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  };

  closeDialog = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const {
      sharedWith,
      readOnly,
      handleDelete,
      refId,
      permissionGrantCommand,
      avatarBorderColor,
      whiteAvatarStackButton,
      blackAvatarStackButton,
      hasStorageInPermissionGrant,
      grantPermissionNoStoreCallback,
      hideButton,
      placement,
    } = this.props;
    const accounts = (sharedWith && sharedWith.accounts) || [];
    const teams = (sharedWith && sharedWith.teams) || [];

    const accountsAvatars = accounts.map((account) => ({
      givenName: account.account.givenName,
      familyName: account.account.familyName,
      avatarSmall: account.account.avatarSmall,
      role: intl.formatMessage(messages[`permission${account.permissionLevel.charAt(0) + account.permissionLevel.slice(1).toLowerCase()}`]),
    }));

    const teamsAvatars = teams.map((team) => ({
      givenName: team.team.name,
      avatarSmall: team.team.avatarSmall,
      role: intl.formatMessage(messages[`permission${team.permissionLevel.charAt(0) + team.permissionLevel.slice(1).toLowerCase()}`]),
    }));

    const collaboratorsAvatars = [...teamsAvatars, ...accountsAvatars];

    const title = (intl.formatMessage(messages.invitePeople));

    return (
      <Fragment>
        { sharedWith
          ? <AvatarStack
            whiteButton={whiteAvatarStackButton}
            blackButton={blackAvatarStackButton}
            avatarBorderColor={avatarBorderColor}
            onClick={this.toggleDialog}
            avatars={collaboratorsAvatars}
            hideButton={hideButton}
            // Below line of code is required to pass rest of the props in case of dynamic tooltip.
            {...this.props} 
          >
            <PopperDialog
              title={title}
              className="sharing-dialog"
              onClose={this.closeDialog}
              placement={placement}
            >
              <InviteView
                collaborators={sharedWith}
                readOnly={readOnly}
                handleDelete={handleDelete}
                refId={refId}
                permissionGrantCommand={permissionGrantCommand}
                hasStorageInPermissionGrant={hasStorageInPermissionGrant}
                grantPermissionNoStoreCallback={grantPermissionNoStoreCallback}
              />
            </PopperDialog>
          </AvatarStack>
          : <AvatarsPlaceholder />
        }
      </Fragment>
    );
  }
}

SharingDialog.propTypes = {
  readOnly: PropTypes.bool,
  sharedWith: collaboratorSummaryShape,
  handleDelete: PropTypes.func,
  refId: PropTypes.string,
  permissionGrantCommand: PropTypes.func,
  avatarBorderColor: PropTypes.string,
  whiteAvatarStackButton: PropTypes.bool,
  blackAvatarStackButton: PropTypes.bool,
  hasStorageInPermissionGrant: PropTypes.bool,
  grantPermissionNoStoreCallback: PropTypes.func,
  hideButton: PropTypes.bool,
};

SharingDialog.defaultProps = {
  hasStorageInPermissionGrant: false,
  grantPermissionNoStoreCallback: () => {},
  hideButton: false,
};

export default SharingDialog;
